export const selectQuickSearch = (state) => state.quickSearch;
